import { GET_PROJECTS_REQUEST_SUCCESS, CREATE_PROJECT_REQUEST_SUCCESS } from "./action";
import Site from "../../interfaces/Site";

export default (state : Site[] = [], action) => {
    switch (action.type){
        case GET_PROJECTS_REQUEST_SUCCESS: 
            return Object.assign([], state, action.payload);
        case CREATE_PROJECT_REQUEST_SUCCESS:
            return [...state, action.payload];
        default:
            return state;
    }
}